import { useLocation } from "react-router-dom";

function useTenantId() {
    const location = useLocation();
    return location.pathname.substring(1).split('/')[0];
}
export default useTenantId;